/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Homepage_Listen_In_LunchInputs */

const en_homepage_listen_in_lunch = /** @type {(inputs: Homepage_Listen_In_LunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eating Lunch`)
};

const es_homepage_listen_in_lunch = /** @type {(inputs: Homepage_Listen_In_LunchInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Almorzando`)
};

/**
* | output |
* | --- |
* | "Eating Lunch" |
*
* @param {Homepage_Listen_In_LunchInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const homepage_listen_in_lunch = /** @type {((inputs?: Homepage_Listen_In_LunchInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Homepage_Listen_In_LunchInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_homepage_listen_in_lunch(inputs)
	return en_homepage_listen_in_lunch(inputs)
});